import { Module } from '@nestjs/common';
import { PrismaService } from '@cart/api-data-access';
import { AuthModule } from '../auth/auth.module';
import { NotificationsModule } from '../notifications/notifications.module';
import { BackupAlertService } from './backup-alert.service';
import { BackupReportService } from './backup-report.service';
import { BackupQuotaService } from './backup-quota.service';
import { BackupService } from './backup.service';
import { DatabaseController } from './database.controller';
import { DatabaseHealthService } from './database-health.service';
import { DbAgentClient } from './db-agent.client';
import { LocalBackupService } from './local-backup.service';
import { MerchantSnapshotService } from './merchant-snapshot.service';
import { RecoveryWindowService } from './recovery-window.service';
import { RestoreService } from './restore.service';
import { RetentionService } from './retention.service';
import { TimeTravelService } from './time-travel.service';
import { WalMonitorService } from './wal-monitor.service';

/**
 * Database backup, PITR, Time Travel and maintenance.
 *
 * Every privileged operation goes through DbAgentClient to the
 * `db-maintenance-agent` daemon; nothing in this module runs pgbackrest, psql
 * or pg_ctl itself. The API process holds no superuser and no shell on purpose,
 * because it is the internet-facing one.
 *
 * `MerchantSnapshotService` is exported so the CSV importer and bulk editors
 * can open a BulkOperationCheckpoint before they start. That checkpoint is what
 * makes "every bulk operation is undoable" affordable — it costs one ~2KB row
 * instead of a full logical dump, which at 10k merchants would be tens of
 * thousands of dumps a day.
 */
@Module({
  imports: [AuthModule, NotificationsModule],
  controllers: [DatabaseController],
  providers: [
    PrismaService,
    DbAgentClient,
    BackupAlertService,
    BackupReportService,
    BackupQuotaService,
    LocalBackupService,
    BackupService,
    WalMonitorService,
    RecoveryWindowService,
    DatabaseHealthService,
    RestoreService,
    RetentionService,
    TimeTravelService,
    MerchantSnapshotService,
  ],
  exports: [MerchantSnapshotService, TimeTravelService],
})
export class DatabaseModule {}
